<!-- Sidebar -->
<p-drawer
  [visible]="viewDuplicateClass()"
  [showCloseIcon]="false"
  position="right"
  [blockScroll]="true"
  [dismissible]="false"
  styleClass="w-full md:w-30rem client-profile-sidebar p-0"
  (onHide)="HideDuplicateClass(false)"
  [dismissible]="!disableSaveBtn"
  appendTo="body"
  [autoZIndex]="true"
  aria-label="duplicate-class-sidebar"
>
  <ng-template #headless>
    <div class="p-sidebar-header"></div>

    <!-- Header -->
    <div
      class="flex border-bottom-1 border-300 surface-0 sticky left-0 top-0 w-full z-2 flex align-items-center justify-content-between"
    >
      <div class="flex align-items-center">
        <!-- Close Icon -->
        <div
          class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center -ml-1"
          (click)="HideDuplicateClass(false)"
          data-testid="close-duplicate-class"
        >
          <i class="fa fa-times text-xl text-600"></i>
        </div>
        <!-- Close Icon -->

        <h4
          class="mb-0 text-sm p-3 text-green-500"
          aria-label="duplicate-class-title"
        >
          {{
            classData().type_name_primary_language ||
              classData().type_name_secondary_language
          }}
        </h4>
      </div>
    </div>
    <!-- Header -->

    <form
      class="p-sidebar-content__wrapper flex flex-column justify-content-between"
      [formGroup]="duplicateClassCreateForm"
      (ngSubmit)="CreateDuplicateClass(duplicateClassCreateForm)"
      aria-label="duplicate-class-form"
    >
      <!-- Content Wrapper -->
      <div class="p-3">
        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="datetime-label"
            >{{ 'SCHEDULE.VIEWCLASS.LBL_DATETIME' | translate }}</label
          >
          <!-- <mbsc-datepicker cssClass="text-sm w-full" [controls]="['datetime']" [themeVariant]="['light']"
          [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
          inputStyle="text-sm m-0 border-400 h-2rem border-round" [touchUi]="false"
          [options]="dateSelectionOption" formControlName="startDate" dateFormat="DD MMM YY">
        </mbsc-datepicker> -->
          <p-datepicker
            inputId="calendar-12h"
            formControlName="startDate"
            [showTime]="true"
            styleClass="text-sm w-full"
            inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
            [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
            [hourFormat]="12"
            aria-label="datetime-calendar"
          />
          @if (StartDateFormControl.touched && StartDateFormControl.invalid) {
            <app-error-msg
              [errors]="StartDateFormControl.errors"
              [fieldLabel]="'SCHEDULE.VIEWCLASS.LBL_STARTDATE' | translate"
            />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        @if (classData() && classData()!.is_recuring) {
          <div class="w-full mb-3">
            <!-- Input Field -->
            @if (
              classData() && classData()!.is_recurring && !RRuleObject.RRule
            ) {
              <div
                class="p-input-icon-right w-full text-sm"
                (click)="showRRule = true"
                data-testid="repeat-input"
              >
                <div
                  class="p-inputtext p-component p-element cursor-pointer bg-blue-50 w-full"
                >
                  {{ 'SCHEDULE.VIEWCLASS.REPEAT' | translate }}
                </div>
              </div>
            }
            @if (
              classData() && classData()!.is_recurring && RRuleObject.RRule
            ) {
              <div
                class="p-input-icon-right w-full text-sm cursor-pointer"
                data-testid="repeat-selected"
              >
                <i
                  class="fa fa-times text-xl text-600"
                  (click)="
                    showRRule = false;
                    RRuleObject.RRule = undefined;
                    RRuleObject.RRuleText = undefined
                  "
                  data-testid="clear-repeat"
                ></i>
                <div
                  class="p-inputtext p-component p-element w-full"
                  (click)="showRRule = true"
                >
                  {{ RRuleObject.RRuleText }}
                </div>
              </div>
            }
            <!-- Input Field -->
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="trainer-label"
            >{{ 'SCHEDULE.CREATECLASS.SELECTTRAINER' | translate }}</label
          >
          <staff-selector
            [formGroup]="duplicateClassCreateForm"
            [controlName]="SelectedTrainerFormControl"
            [id]="selectedTrainerId"
            [styleClass]="'w-full text-sm'"
            [placeHolder]="'common.PLACEHOLDER.SEARCH_AND_SELECT' | translate"
            [filterstaff]="filterStaffIds"
            aria-label="trainer-selector"
          />
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="location-label"
            >{{
              'SCHEDULE.VIEWCLASS.LBL_LOCATION' | translate | uppercase
            }}</label
          >
          @if (!duplicateClass) {
            <ff-google-places
              [competitorName]="PlaceNameControl"
              [placeId]="classData().place_id"
              [placeHolderName]="
                'SCHEDULE.VIEWCLASS.SEARCH_LOCATION' | translate
              "
              (fetchPlaceInfo)="getPlaceDetails($event)"
              aria-label="location-search"
            />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        @if (isVirtal) {
          <div class="mb-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="virtual-url-label"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_VIRTUALURL' | translate }}</label
            >
            <input
              type="url"
              class="text-sm w-full"
              pInputText
              formControlName="virtualUrl"
              #keyUpInputDelay
              placeholder="{{ 'SCHEDULE.VIEWCLASS.VIRTUALURL' | translate }}"
              (keyup)="onKeyUpDelay(keyUpInputDelay.value)"
              aria-label="virtual-url-input"
            />
            @if (
              VirtualUrlFormControl.touched && VirtualUrlFormControl.invalid
            ) {
              <app-error-msg
                [errors]="VirtualUrlFormControl.errors"
                [fieldLabel]="
                  'SCHEDULE.CREATEAPPOINTMENT.LBL_VIRTUALURL' | translate
                "
              />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        @if (!isVirtal) {
          <div class="mb-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="room-label"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_ROOM' | translate }}</label
            >
            <select-room
              [formGroup]="duplicateClassCreateForm"
              [controlName]="SelectedRoomFormControl"
              [tenantId]="tenantId()"
              [roomId]="selectedRoomId"
              [styleClass]="'w-full text-sm'"
              aria-label="room-selector"
            />
            @if (
              SelectedRoomFormControl.touched && SelectedRoomFormControl.invalid
            ) {
              <app-error-msg
                [errors]="SelectedRoomFormControl.errors"
                [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_ROOM' | translate"
              />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="comments-label"
            >{{ 'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate }}</label
          >
          <textarea
            pInputTextarea
            class="w-full text-sm h-6rem"
            formControlName="comments"
            placeholder="{{ 'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate }}"
            aria-label="comments-textarea"
          >
          </textarea>
        </div>
        <!-- Form Group -->

        <!-- it will implemented after UAT -->
        <!-- Form Group -->
        <!-- <div class="mb-3">
          <div class="flex align-items-center">
            <p-toggleSwitch formControlName="accepts_trial"></p-toggleSwitch>
            <p class="text-sm mb-0 ml-3 -mt-1">{{'SCHEDULE.CREATECLASS.ACCEPT_TRIALS' | translate}}</p>
          </div>
        </div> -->
        <!-- Form Group -->

        <!-- Row -->
        <div
          class="md:flex flex-wrap justify-content-between relative border-top-1 border-300"
        >
          <!-- Form Group -->
          <div class="md:mb-0 my-3 md:w-5 md:pr-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="subpurpose-label"
              >{{ 'SCHEDULE.VIEWAPPOINTMENT.SUBPURPOSE' | translate }}</label
            >
            <p-select
              [options]="classSubTypeList$"
              formControlName="classSubType"
              optionLabel="name_primary_language"
              filterBy="name_primary_language"
              styleClass="md:w-full align-items-center text-sm border-none p-0 -mt-2"
              aria-label="subpurpose-dropdown"
            >
              <ng-template pTemplate="selectedItem">
                @if (GetSelectedClassSubType) {
                  <div class="text-sm font-bold">
                    {{ GetSelectedClassSubType.name_primary_language }}
                  </div>
                }
              </ng-template>
              <ng-template let-subpurpose pTemplate="item">
                <div class="text-sm ml-2">
                  {{ subtype.name_primary_language }}
                </div>
              </ng-template>
            </p-select>
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="md:mb-0 my-3 md:w-7">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="class-type-label"
              >{{ 'SCHEDULE.VIEWCLASS.CLASS_TYPE' | translate }}</label
            >
            <p-select
              [options]="classBehaviourTypes"
              formControlName="selectedBehaviourType"
              optionLabel="name"
              filterBy="name"
              styleClass="md:w-full align-items-center text-sm border-none p-0 -mt-2"
              (onChange)="selectAction($event)"
              aria-label="class-type-dropdown"
            >
              <ng-template pTemplate="selectedItem">
                @if (GetSelectedBehaviour) {
                  <div class="text-sm flex align-items-center font-bold">
                    <i
                      class="{{ GetSelectedBehaviour.icon }} text-500 mr-2"
                      aria-label="class-type-icon"
                    ></i>
                    {{ GetSelectedBehaviour.name }}
                  </div>
                }
              </ng-template>
              <ng-template let-classType pTemplate="item">
                <div class="text-sm flex align-items-center">
                  <i
                    class="{{ classType.icon }} text-500 mr-2"
                    aria-label="class-type-icon"
                  ></i>
                  {{ classType.name }}
                </div>
              </ng-template>
            </p-select>
          </div>
          <!-- Form Group -->
        </div>
        <!-- Row -->

        <!-- Row -->
        <div
          class="md:flex flex-wrap justify-content-between relative border-top-1 border-300"
        >
          <!-- Form Group -->
          <div class="md:mb-0 my-3 pr-3 w-6 md:w-5">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase white-space-nowrap"
              aria-label="reservation-limit-label"
              >{{ 'SCHEDULE.VIEWCLASS.RESERVATION_LIMIT' | translate }}</label
            >
            @if (!maxCapacityEdit) {
              <strong
                (click)="maxCapacityEdit = true"
                class="block cursor-pointer border-round hover:surface-200 p-2 md:w-6rem"
                data-testid="edit-reservation-limit"
              >
                {{ GetMaxCapacityFormValue | number }}
              </strong>
            }

            @if (maxCapacityEdit) {
              <div class="p-inputgroup md:w-6rem">
                <!-- <p-inputNumber [format]="false" class="w-full text-sm" formControlName="maxCapacity" min="0"></p-inputNumber> -->
                <app-input-number
                  [formGroup]="duplicateClassCreateForm"
                  [controlName]="duplicateClassCreateForm.get('maxCapacity')"
                  [styleClass]="'w-full text-sm'"
                  [conditionToFormat]="false"
                  [mode]="'number'"
                  aria-label="reservation-limit-input"
                />
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-times text-xl"
                  class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
                  (click)="EditMaxCapacity(false)"
                  aria-label="cancel-reservation-limit-button"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-check"
                  class="p-button-secondary"
                  (click)="EditMaxCapacity(true)"
                  aria-label="save-reservation-limit-button"
                ></button>
              </div>
            }
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="md:mb-0 my-3 md:pr-3 w-6 md:w-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="waitlist-label"
              >{{ 'SCHEDULE.VIEWCLASS.WAIT_LIST' | translate }}</label
            >
            @if (!waitListEdit) {
              <strong
                class="block cursor-pointer border-round hover:surface-200 p-2 md:w-5rem relative z-2"
                (click)="waitListEdit = true"
                data-testid="edit-waitlist"
              >
                {{ GetMaxWaitListFormValue | number }}
              </strong>
            }

            @if (waitListEdit) {
              <div class="p-inputgroup md:w-5rem relative z-2">
                <!-- <p-inputNumber [format]="false" class="w-full text-sm" formControlName="maxWaitlist" min="0"></p-inputNumber> -->
                <app-input-number
                  [formGroup]="duplicateClassCreateForm"
                  [controlName]="duplicateClassCreateForm.get('maxWaitlist')"
                  [styleClass]="'w-full text-sm'"
                  [conditionToFormat]="false"
                  [mode]="'number'"
                  aria-label="waitlist-input"
                />
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-times text-xl"
                  class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
                  (click)="EditMaxWaitlist(false)"
                  aria-label="cancel-waitlist-button"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-check"
                  class="p-button-secondary"
                  (click)="EditMaxWaitlist(true)"
                  aria-label="save-waitlist-button"
                ></button>
              </div>
            }
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="md:pr-3 my-3 w-12 md:w-4">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="drop-in-label"
              >{{ 'SCHEDULE.VIEWCLASS.DROP_IN' | translate }}</label
            >
            <p-select
              [options]="dropIns"
              formControlName="isDropInAllowed"
              optionLabel="name"
              filterBy="name"
              styleClass="md:w-full align-items-center text-sm border-none p-0 -mt-2 md:w-7rem"
              aria-label="drop-in-dropdown"
            >
              <ng-template pTemplate="selectedItem">
                @if (GetDropInFormValue) {
                  <div class="text-sm font-bold">
                    {{ GetDropInFormValue.name }}
                  </div>
                }
              </ng-template>
              <ng-template let-dropIn pTemplate="item">
                <div class="text-sm">{{ dropIn.name }}</div>
              </ng-template>
            </p-select>
          </div>
          <!-- Form Group -->
        </div>
        <!-- Row -->
      </div>
      <!-- Content Wrapper -->

      <!-- Footer -->
      <div
        class="sticky bottom-0 left-0 z-3 flex align-items-center justify-content-between border-top-1 border-300 p-3 surface-0"
      >
        <div class="w-4">
          <p-button
            type="button"
            [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
            class="p-button-secondary p-button-text text-sm"
            (click)="HideDuplicateClass(false)"
            styleClass="p-button-link text-sm"
            aria-label="cancel-duplicate-class-button"
          />
        </div>
        <div class="w-8 text-right">
          <button
            pButton
            pRipple
            type="submit"
            [label]="'SCHEDULE.VIEWCLASS.BTN_SAVE_DUP_CLASS' | translate"
            class="text-sm"
            [disabled]="disableSaveBtn"
            [loading]="disableSaveBtn"
            aria-label="save-duplicate-class-button"
          ></button>
        </div>
      </div>
      <!-- Footer -->
    </form>
  </ng-template>
</p-drawer>
<!-- Sidebar -->

<app-rrule
  [visible]="showRRule"
  (onHide)="HideRRule({})"
  [showNeverStop]="true"
  [rRuleObj]="RRuleObject"
  (hideRrule)="HideRRule($event)"
  (emitRRule)="FetchRRuleData($event)"
/>

@if (showErrorPopup$ | async; as showPopup) {
  <app-errors
    [error]="error"
    [visible]="showPopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
  />
}
